import React from 'react';
import './styles/Footer.css';
import logo from '../assets/blue-green-logo.png'; // Adjust path if needed

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo-col">
          <img src={logo} alt="Movingbay Logo" className="footer-logo" />
          <p className="footer-brand">Movingbay</p>
          <div className="footer-links">
            <a href="#">Welcome to MovingBay, your trusted partner in pet relocation and pet transportation services!</a>
          </div>
        </div>
        <div className="footer-col">
          <h3>Contact:</h3>
          <div className="footer-links">
            <p>+91 8618173141</p>
            <p>info@movingbay.com</p>
             <p>
            Address: #12 Teja Vihar, Portion a 1st Floor, Basavanpura Road, Bhattrahalli, Bangalore North, Bangalore, Karnataka - 560036
          </p>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="copyright">
          &copy; {new Date().getFullYear()} Movingbay. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
